import React from 'react';
import styles from './ProfessorPositions.module.css'; // Add this import

function PositionTabs({ currentTab, onTabChange }) {
  const tabs = [
    { id: 'view', label: 'My Positions' },
    { id: 'create', label: 'Create Position' }
  ];

  return (
    <div className={styles.positionTabsCard}>
      <h2 className={styles.tabsHeading}>Position Actions</h2>
      <div className={styles.tabsContainer}>
        {tabs.map(tab => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`${styles.tabButton} ${currentTab === tab.id ? styles.active : styles.inactive}`}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
}

export default PositionTabs;
